import React, { FC } from "react";
import { Constants } from "../constants";

const PageNotFound: FC = () => {
  return <h1>{Constants.PAGE_NOT_FOUND}</h1>;
};

export default PageNotFound;
